import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import { AUTH_FACEBOOK, AUTH_GOOGLE } from '../../../graphql/mutations/auth';

import { AuthConsumer } from '../../../context/auth';

import style from './index.module.scss';

function SocialLogin({ changeSignupMethod }) {
  const { social, paragraph, icon, link } = style;

  const handleFacebookAuth = async (authFacebook, handleAuthentication) => {
    const resp = await authFacebook({
      variables: {
        input: {
          accessToken: 'to be added',
        },
      },
    });

    console.log('Fcb', resp);
  };

  const handleGoogleAuth = async (authGoogle, handleAuthentication) => {
    const resp = await authGoogle({
      variables: {
        input: {
          accessToken: 'to be added',
        },
      },
    });

    console.log('Fcb', resp);
  };

  return (
    <div className={`row ${social}`}>
      <Mutation mutation={AUTH_FACEBOOK}>
        {(authFacebook, { loading, error, data }) => (
          <AuthConsumer>
            {({ handleAuthentication }) => (
              <button
                className={`btn ${style['button-google']}`}
                onClick={() =>
                  handleFacebookAuth(authFacebook, handleAuthentication)
                }
              >
                <span className={`${icon} ${style['icon-google']}`}>
                  <i className='fab fa-google' />
                </span>{' '}
                Continue with Google
              </button>
            )}
          </AuthConsumer>
        )}
      </Mutation>
      <Mutation mutation={AUTH_GOOGLE}>
        {(authGoogle, { loading, error, data }) => (
          <AuthConsumer>
            {({ handleAuthentication }) => (
              <button
                className={`btn ${style['button-facebook']}`}
                onClick={() =>
                  handleGoogleAuth(authGoogle, handleAuthentication)
                }
              >
                <span className={icon}>
                  <i className='fab fa-facebook' />
                </span>{' '}
                Continue with Facebook
              </button>
            )}
          </AuthConsumer>
        )}
      </Mutation>
      <div className={style['col-12']}>
        <p className={paragraph}>
          <span className={style['with-email']} onClick={changeSignupMethod}>
            Continue With Email
          </span>
          . By signing up you indicate that you have read and agree to{' '}
          <Link to='#' className={link}>
            Quora's Terms of Service
          </Link>{' '}
          and{' '}
          <Link to='#' className={link}>
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
}

SocialLogin.propTypes = {
  changeSignupMethod: PropTypes.func.isRequired,
};

export default SocialLogin;
